import { Button, Input, Popconfirm, Space, Switch, message } from 'antd'
import React from 'react'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'
import TextArea from 'antd/es/input/TextArea'

const SettingChange = ({ data, mutate = () => {} }) => {
	const type = data?.id?.split('_')[1]?.split(':')[0]
	const { data: token } = useToken()
	const [value, setValue] = React.useState(data?.setting)

	return (
		<Space style={{ width: '100%', flex: 1 }}>
			{type == 'B' && (
				<Popconfirm
					title="수정하시겠습니까? 시스템수정시 주의가 필요합니다."
					onConfirm={() => {
						API.send('PUT', '/admin/setting', token + '', {
							id: data?.id,
							setting: value ? 0 : 1,
						}).then(res => {
							message.success('수정되었습니다.')
							setValue(!value)
							mutate()
						})
					}}>
					<Switch checked={value == 1 ? true : false} />
				</Popconfirm>
			)}
			{type == 'T' && (
				<Space style={{ width: '100%', flex: 1 }}>
					<TextArea
						style={{
							width: '100%',
							flex: 1,
							minBlockSize: 100,
							minInlineSize: 500,
						}}
						size="middle"
						value={value}
						onChange={e => {
							setValue(e.target.value)
						}}
					/>
					<Popconfirm
						title="수정하시겠습니까? 시스템수정시 주의가 필요합니다."
						onConfirm={() => {
							API.send('PUT', '/admin/setting', token + '', {
								id: data?.id,
								setting: value,
							}).then(res => {
								message.success('수정되었습니다.')
								mutate()
							})
						}}>
						<Button size="small" type="primary">
							수정
						</Button>
					</Popconfirm>
				</Space>
			)}
			{type != 'B' && type != 'T' && (
				<>
					<Input
						value={value}
						onChange={e => {
							setValue(e.target.value)
						}}
					/>
					<Popconfirm
						title="수정하시겠습니까? 시스템수정시 주의가 필요합니다."
						onConfirm={() => {
							API.send('PUT', '/admin/setting', token + '', {
								id: data?.id,
								setting: value,
							}).then(res => {
								message.success('수정되었습니다.')
								mutate()
							})
						}}>
						<Button size="small" type="primary">
							수정
						</Button>
					</Popconfirm>
				</>
			)}
		</Space>
	)
}

export default React.memo(SettingChange)
